class ImagePopup extends HTMLElement {
  constructor() {
    super();

    if (window.location.pathname === '/challenge') {
      return;
    }

    this.cookieName = 'fusion:image-popup';
    this.popup = this;
    this.classes = {
      bodyClass: 'image-popup-open',
      overlayClass: 'overflow-hidden',
      activeClass: 'is-visible',
      closingClass: 'closing',
    };

    this.querySelectorAll('[data-popup-close]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });

    if (!this.getCookie(this.cookieName)) {
      this.init();
    }
  }

  init() {
    if (!this.popup) {
      return;
    }

    const delay = parseInt(this.dataset.delay || '2', 10) * 1000;
    setTimeout(() => {
      this.open();
    }, delay);
  }

  onButtonClick(event) {
    event.preventDefault();
    if (this.popup.classList.contains(this.classes.activeClass)) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    if (this.dataset.imagepopup === 'true') {
      document.body.classList.add(this.classes.bodyClass);
      this.popup.classList.add(this.classes.activeClass);
      document.body.classList.add(this.classes.overlayClass);
    }
  }

  close() {
    this.popup.classList.add(this.classes.closingClass);
    document.body.classList.remove(this.classes.overlayClass);
    this.popup.classList.remove(this.classes.activeClass);

    setTimeout(() => {
      this.popup.classList.remove(this.classes.closingClass);
    }, 50);

    const expiry = parseInt(this.dataset.expiry || '5', 10);
    this.setCookie(this.cookieName, expiry);
  }

  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  setCookie(name, expiry) {
    document.cookie = `${name}=true; max-age=${expiry * 24 * 60 * 60}; path=/`;
  }
}

customElements.define('image-popup', ImagePopup);
